import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { DadosEmpresaService } from 'src/app/services/dados-empresa.service';
import { DomUtilsService } from '@utils/DomUtilsService';
import { PageLayoutComponent } from '../../components/page-layout/page-layout.component';
import { NgxMaskDirective } from 'ngx-mask';
import { SelectComponent } from '../../components/select/select.component';
import { NgClass } from '@angular/common';
import {AlertErroCustomizadoComponent} from "../../components/alert-erro-customizado/alert-erro-customizado.component";

@Component({
    selector: 'app-adicionar-filial',
    templateUrl: './adicionar-filial.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PageLayoutComponent, FormsModule, ReactiveFormsModule, NgxMaskDirective, SelectComponent, NgClass, AlertErroCustomizadoComponent]
})
export class AdicionarFilialComponent implements OnInit {

  public idEmpresaLogada: string = localStorage.idEmpresaLogada;
  public formulario: UntypedFormGroup;
  public ramosAtividadeApi: any = null;

  // VARIAVEIS DOS ALERTS
  public alertLoading: boolean = false;
  public alertSucesso: boolean = false;
  public alertError: boolean = false;
  public mensagemErro: string = '';
  public tituloMensagemErro: string = '';

  constructor(
    private readonly formularioBuilder: UntypedFormBuilder,
    private readonly service: DadosEmpresaService,
    private readonly domUtils: DomUtilsService,
    public rota: Router
    ) {
  }

  ngOnInit(): void {
    this.consultaRamosAtividades();
    this.contruirFormulario();
  }

  contruirFormulario() {
    this.formulario = this.formularioBuilder.group({
      'cnpj': ['', Validators.compose([ Validators.required, Validators.minLength(14) ])],
      'nmSocial': ['', Validators.compose([ Validators.required, Validators.maxLength(80) ])],
      'nmFantasia': ['', Validators.compose([ Validators.required, Validators.maxLength(30) ])],
      'rmAtividade': ['', Validators.compose([ Validators.required ])],
      'insEstadual': ['', Validators.compose([ Validators.required ])],
      'insMunicipal': ['', Validators.compose([ Validators.required ])]
    });

    this.formulario.get('cnpj')?.valueChanges.subscribe(value => {
      const upper = value?.toUpperCase();
      if (value !== upper) {
        this.formulario.get('cnpj')?.setValue(upper, { emitEvent: false });
      }
    });
  }

  consultaRamosAtividades() {

    this.service.getRamosAtividades()
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
          if(response.status === 'OK') {
          this.ramosAtividadeApi = response.response;
        } else { this.ramosAtividadeApi = false; }
      },
      error: (error: any) => {
        this.ramosAtividadeApi = false;
        console.error(error);
      }
    });
  }

  adicionarFilial() {

    this.mensagemErro = '';
    this.alertLoading = true;
    this.formulario.value.rmAtividade = Number.parseInt(this.formulario.value.rmAtividade);

    let objFilial: any = {
      "CNPJ": this.formulario.value.cnpj,
      "insEstadual": this.formulario.value.insEstadual,
      "insMunicipal": this.formulario.value.insMunicipal,
      "nmFantasia": this.formulario.value.nmFantasia,
      "nmSocial": this.formulario.value.nmSocial,
      "rmAtividade": this.formulario.value.rmAtividade
    }
    this.service.createNewFilial(this.idEmpresaLogada, objFilial)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.alertLoading = false;
        if(response.status === 'OK') {
          this.alertSucesso = true;
        } else {
          this.alertError = true;
          this.mensagemErro = response.mensagem;
          this.tituloMensagemErro = 'Erro ao Adicionar Filial'
        }
      },
      error: (error: any) => {
        this.alertLoading = false;
        this.alertError = true;
        this.mensagemErro = error.mensagem;
        this.tituloMensagemErro = 'Erro ao Adicionar Filial'
      }
    });
  }

  voltarAbaFilial() {
    this.rota.navigate(['dados-empresa']);
    this.domUtils.aguardarElementoClique('filiaisTab', 1500, 3)
  }

  fecharAlertSucesso(evento: string) {
    this.alertSucesso = false;
    this.rota.navigate(['dados-empresa']);
    this.domUtils.aguardarElementoClique('filiaisTab', 1200, 4);
  }

  fecharAlertError(evento: string) { this.alertError = false; }
}
